export default "__VITE_ASSET__CbIh23PY__"